
import { Component, Mixins } from "vue-property-decorator";
import Header from "./components/header.vue";
import Navigation from "./components/navigation.vue";
import AuthMixin from "@/common/mixins/auth.mixin";

@Component({
  components: {
    Header,
    Navigation
  }
})
export default class BaseComponent extends Mixins(AuthMixin) {}
